import { render, staticRenderFns } from "./sa-organization-update.html?vue&type=template&id=7145e278&scoped=true&"
import script from "./sa-organization-update.js?vue&type=script&lang=js&"
export * from "./sa-organization-update.js?vue&type=script&lang=js&"
import style0 from "./sa-organization-update.scss?vue&type=style&index=0&id=7145e278&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145e278",
  null
  
)

export default component.exports